<template lang="pug">
mixin groupList
  v-card(:class='{ sticky: !isMobile }' flat)
    v-list(:dense='isMobile')
      v-slide-x-transition(group hide-on-leave)
        v-list-tile.list-item(v-for='(i, index) in groupList' :key='i' @click='selectedGroup = index' :class='selectedGroup === index && `active`')
          v-list-tile-content
            v-list-tile-title(:class='{ closed: !groupConfig[i].isOpen }') {{ convertGroupText(i) }}組
          v-list-tile-action
            v-switch(color='primary' v-model='groupConfig[i].isOpen')
      v-divider(v-if='groupConfig')
      v-menu(max-height='400' nudge-right='50')
        v-btn(slot='activator' flat :small='isMobile' :disabled='!groupConfig' color='primary')
          v-icon(left) add
          | 新增組別
        v-list(subheader)
          v-subheader 新增開放報名的組別
          v-list-tile(@click='addGroup(i.id)' v-for='i in groupTableList' :key='i.id' v-if='!groupList.some(v => +v === +i.id)')
            v-list-tile-action: v-icon add
            v-list-tile-title {{ i.name }}

.mb-5
  PageTitle
    v-menu(:close-on-content-click='false' :nudge-width='200' offset-x v-if='isMobile')
      v-btn.my-0(slot='activator' color='primary' flat icon small title='編輯')
        v-icon fas fa-caret-down
      +groupList
    ModifiedDot.ml-2(:show='isModified' color='primary')

  v-alert.mb-2(:value='isSubmitSuccess && !isOpen' type='info' outline)
    | 提示：目前仍為關閉報名狀態，若欲恢復請至#[router-link(:to='{ name: `config` }') 設定]開啟。

  v-card
    v-alert(type='error' :value='true' v-if='groupConfig === false' icon='warning') {{ $t('errorWhileLoading') }} {{ error }}
    v-alert(type='error' :value='true' v-else-if='isSaveFailed && error' icon='warning') {{ $t('failedToSave') }} {{ error.response }}

  v-container.pa-0(grid-list-lg)
    v-layout(row wrap)
      v-flex(xs12 md4 lg3 v-if='!isMobile')
        +groupList

      v-flex(xs12 md8 lg9)
        Loader(:show='groupConfig === null')

        v-form(v-model='valid'  v-if='groupConfig')
          v-card(v-for='(group, gIndex) in groupList' v-if='gIndex === selectedGroup' :key='gIndex')
            v-toolbar(card)
              v-toolbar-title.mr-2 {{ convertGroupText(group) }}組
              v-chip(
                small
                :color='groupConfig[group].isOpen ? `success` : ``'
                :text-color='groupConfig[group].isOpen ? `white` : ``'
              ) {{ groupConfig[group].isOpen ? `開放報名` : `關閉` }}
              v-spacer
              v-menu(bottom right)
                v-btn(slot='activator' icon): v-icon more_vert
                v-list
                  v-list-tile(@click='removeGroup(group)')
                    v-list-tile-avatar: v-icon.mr-2(color='error') fas fa-trash-alt
                    v-list-tile-title.error--text 移除此組別

            v-card-text
              v-alert(:value='isOpen' type='warning')
                | 開放報名期間無法修改#[b 人數上限]與#[b 報名費用]，欲修改請先至#[router-link.white--text(:to='{ name: `config` }') 設定]調整開放狀態。

              v-layout(row wrap)
                v-flex(xs12)
                  v-switch(color='primary' v-model='groupConfig[group].isOpen' hide-details)
                    template(slot='label')
                      | {{ $t('registrationStatus') }}:
                      strong {{ groupConfig[group].isOpen ? $t('accepting') : $t('closed') }}

              v-layout(row wrap)
                v-flex(xs12 sm6 lg4)
                  v-subheader.pl-0.mt-2 組員人數
                  v-select(v-model.number='groupConfig[group].numOfPartner' :items='partnerNumberSelectList' label='人數上限 *' @change='handleFeeSpecific' :disabled='isOpen')

              v-layout(row wrap)
                template(v-if='isECPay')
                  v-flex(xs12 sm6 lg4)
                    v-subheader.pl-0.mt-2(@click='handleFeeSpecific') 報名費
                    v-text-field(label='基準費用 *' type='number' prefix='NT$' v-model.number='groupConfig[group].fee' :rules='rules.fee' v-if='isECPay' :disabled='isOpen' maxlength='4')

                  v-flex(xs12)
                    v-subheader.pl-0.mt-2
                      span 依組員人數調整報名費
                        v-btn(color='primary' flat icon small @click='isEditingFeeSpecific = true' v-if='!isEditingFeeSpecific' :disabled='isOpen' title='編輯'): v-icon(small) edit
                    //- 人數區段顯示
                    v-timeline(dense v-show='!isEditingFeeSpecific')
                      v-slide-x-transition(group hide-on-leave)
                        v-timeline-item(
                          small
                          v-for='(i, index) in convertFeeSpecific(groupConfig[group].feeSpecific,groupConfig[group].numOfPartner)'
                          :key='index'
                          :color='!isFeeDefault(i.value) ? `primary` : ``'
                        )
                          v-layout(wrap)
                            template
                              v-flex.py-1(xs3 sm2 xl1)
                                span(v-if='i.keys.length === 1') {{ i.keys[0] }}
                                span(v-else) {{ Math.min(...i.keys) }}~{{ Math.max(...i.keys) }}
                                |  人
                              v-flex.py-1
                                strong.primary--text(v-if='!isFeeDefault(i.value)')
                                  | NT$ {{ i.value }}
                                div(v-else)
                                  | NT$ {{ groupConfig[group].fee }}
                                  small.grey--text  (同基準費用)

                    //- 編輯
                    v-timeline(dense align-top v-show='isEditingFeeSpecific')
                      v-slide-x-transition(group hide-on-leave)
                        v-timeline-item(v-for='i in groupConfig[group].numOfPartner + 1' :key='i')
                          template(v-slot:icon): .white--text.no-wrap {{ i - 1 }}人
                          v-layout(wrap)
                            v-flex.py-0(xs12 sm6 lg4)
                              v-text-field(
                                type='number'
                                prefix='NT$'
                                maxlength='4'
                                :placeholder='`${groupConfig[group].fee} (同基準費用)`'
                                v-model.trim.number='groupConfig[group].feeSpecific[i - 1]'
                                :rules='rules.feeSpecific'
                                :disabled='isOpen'
                                hide-details
                                clearable
                              )
                    .pl-1.pt-3.pb-2: h6(v-if='isEditingFeeSpecific').grey--text
                      | 欄位留空時會直接套用上方的基準費用

                    v-btn(flat small color='primary' v-if='isEditingFeeSpecific' @click='isEditingFeeSpecific = false')
                      v-icon(left) check
                      | 完成

                v-flex(xs12)
                  v-subheader.pl-0.mt-2
                    span 器材數量上限
                    v-tooltip(right)
                      v-btn.ma-0(small icon flat :ripple='false' slot='activator'): v-icon(small color='grey') fas fa-question-circle
                      span 設定各個樂器可以填寫的最大值，若設為 0 即隱藏該欄位

                  v-layout(row wrap)
                    v-flex.py-0(xs6 sm4 md3 lg2 v-for='i in equipmentKeyList' v-if='groupConfig[group][i]' :key='i')
                      NumberPicker.mb-2.mt-1(v-model.number='groupConfig[group][i].max' :max='10' :label='convertEquipmentText(i)')
                    v-flex.py-0(xs12)
                      v-checkbox(label='使用效果器' v-model='groupConfig[group].isEffector' color='primary')

              v-subheader.pl-0.mt-2
                span  自定義欄位
                v-btn(color='primary' flat icon small @click='addCustomField(group)' v-if='groupConfig[group]' :disabled='groupConfig[group].customField.length >= 10'): v-icon(small) add

              div
                h6.grey--text(v-if='!groupConfig[group].customField.length') 點擊 + 按鈕新增項目
                draggable(v-else v-model='groupConfig[group].customField' handle='.handle')
                  div(v-for='(i, index) in groupConfig[group].customField' :key='index')
                    v-layout(align-end)
                      v-flex(shrink): .handle: v-icon(color='grey') dehaze
                      v-flex
                        CustomField(v-model='groupConfig[group].customField[index]' :disabled='isHandling' :index='index' @remove='removeCustomField(group, index)')

  StickyBottomSaveContent(:loading='!groupConfig || isSaving' :show='isModified' :disabled='!groupConfig || isSaving' :valid='valid' @submit='submit' @cancel='discard')

  DebugCodeBlock(:value='groupConfig')
  SnackbarSuccess(ref='successSnackbar')
</template>

<script>
import apis from '@/assets/js/apis'
import { formStatus } from '@/mixins/formStatus'
import Loader from '@/components/Loader.vue'
import ToolbarSaveContent from '@/components/ToolbarSaveContent.vue'
import StickyBottomSaveContent from '@/components/StickyBottomSaveContent.vue'
import SnackbarSuccess from '@/components/SnackbarSuccess.vue'
import draggable from 'vuedraggable'
import NumberPicker from '@/components/NumberPicker.vue'
import PageTitle from '@/components/PageTitle.vue'
import CustomField from '@/components/config/CustomField.vue'

export default {
  name: 'GroupEdit',
  metaInfo () {
    return {
      title: this.$t('組別規則'),
    }
  },
  data () {
    this.rules = {
      fee: [
        v => (v && /^[0-9]*[1-9][0-9]*$/.test(v)) || v === 0 || '必須是正整數',
        v => (+v >= 0 && +v <= 9999) || '必須是 0 至 9999 之間的整數',
      ],
      feeSpecific: [
        v => (/^[0-9]*[1-9][0-9]*$/.test(v)) || v === '' || v === null || v === 0 || '必須是正整數',
        v => (+v >= 0 && +v <= 9999) || '必須是 0 至 9999 之間的整數',
      ],
      numOfPartner: [
        v => (v && /^[0-9]*[1-9][0-9]*$/.test(v)) || v === 0 || '必須是正整數',
        v => (+v >= 0 && +v <= 10) || '必須是 0 至 10 之間的整數',
      ],
    }
    this.partnerNumberSelectList = [...Array(11)].map((_, index) => {
      return { text: `${index}人`, value: index }
    })

    return {
      groupConfig: null,
      selectedGroup: 0,
      isHandling: false,
      isEditingFeeSpecific: false,
      isSubmitSuccess: false,
    }
  },
  mounted () {
    this.fetch()
  },
  methods: {
    async fetch () {
      this.groupConfig = null
      this.isEditingFeeSpecific = false

      try {
        this.groupConfig = await apis.config.group.get(this.token) || null
        this.clearIsModified()
        this.handleFeeSpecific()
      } catch (e) {
        this.error = e
        this.groupConfig = false
      }
    },
    async submit () {
      if (!this.valid) return
      const body = { ...this.groupConfig }
      this.isSaving = true
      this.clearError()
      this.handleFeeSpecific()
      try {
        await apis.config.group.put(body, this.token)
        this.$emit('success')
        this.fetch()
        this.isSaving = false
        this.$refs.successSnackbar.show('成功發佈組別規則')
        this.isSubmitSuccess = true
        this.clearIsModified()
        this.$store.commit('setUserInfoLastUpdate', 0)
      } catch (e) {
        this.isSaveFailed = true
        this.isSaving = false
        this.error = e
      }
    },
    discard () {
      this.groupConfig = null
      this.clearIsModified()
      this.fetch()
    },
    addGroup (group) {
      // 新增預設空白組別
      this.$set(this.groupConfig, group, {
        KB: { max: 1 },
        mic: { max: 1 },
        guitar: { max: 1 },
        bass: { max: 1 },
        cajon: { max: 1 },
        micStand: { max: 1 },
        isEffector: true,
        numOfPartner: 5,
        customField: [],
        fee: 0,
        isOpen: true,
      })
      this.handleFeeSpecific()

      this.$nextTick(() => {
        this.selectedGroup = this.groupList.findIndex((item) => item === group)
      })
    },
    removeGroup (group) {
      const name = this.convertGroupText(group)
      if (confirm(`是否確認移除「${name}組」?`)) {
        this.$delete(this.groupConfig, group)
        window.scrollTo(0, 0)
      }
    },
    addCustomField (group) {
      this.groupConfig[group].customField.push({
        label: '',
        isRequired: false,
        isMultiLine: false,
      })
    },
    removeCustomField (group, index) {
      this.isHandling = true
      this.$nextTick(() => {
        this.groupConfig[group].customField.splice(index, 1)
        this.isHandling = false
      })
    },
    handleFeeSpecific () {
      const groupConfig = this.groupConfig
      if (!this.isECPay) return

      Object.keys(groupConfig).forEach(key => {
        const group = groupConfig[key] // 各組別物件
        const feeSpecific = group.feeSpecific || {}
        const newFeeSpecific = {}
        if (this.isFeeDefault(group.fee) || group.fee === undefined) { // 初始還未有 fee 值時
          group.fee = 0
        }

        for (let i = 0; i <= group.numOfPartner; i++) {
          const value = feeSpecific[i]
          if (this.isFeeDefault(value) || !Number.isInteger(value)) {
            newFeeSpecific[i] = null
          } else {
            newFeeSpecific[i] = value
          }
        }
        group.feeSpecific = newFeeSpecific
      })
    },
    isFeeDefault (_) {
      return [null, ''].some(i => i === _)
    },
    convertFeeSpecific (_, max) {
      const result = []

      for (let i = 0; i <= max; i++) {
        if (result.length === 0) {
          result.push({ keys: [i], value: _[i] })
        } else {
          const lastIndex = result.length - 1
          if (result[lastIndex].value === _[i]) {
            result[lastIndex].keys.push(i)
          } else {
            result.push({ keys: [i], value: _[i] })
          }
        }
      }
      return result
    },
  },
  computed: {
    // 取得某些樂器的 key 值
    equipmentKeyList () {
      const list = []
      for (const key in this.equipmentTable) {
        if (['effector', 'other', 'chair'].indexOf(key) < 0) { list.push(key) }
      }
      return list
    },
    // 根據 equipment 物件產生的組別列表(為了按照順序迭代用)
    groupList () {
      const list = []
      for (const key in this.groupConfig) { list.push(+key) }
      return list.sort((a, b) => a - b)
    },
    isECPay () {
      return this.$store.state.userInfo ? !!this.$store.state.userInfo.isECPay : false
    },
    isOpen () {
      return this.$store.state.userInfo && this.$store.state.userInfo.isOpen
    },
    currentGroupText () {
      const id = this.groupList[this.selectedGroup]
      if (!id) return null
      return this.convertGroupText(id)
    },
  },
  watch: {
    isEditingFeeSpecific () {
      this.handleFeeSpecific()
    },
    groupConfig: {
      handler (newValue) {
        this.isModified = true
      },
      deep: true,
    },
  },
  components: {
    Loader,
    ToolbarSaveContent,
    StickyBottomSaveContent,
    SnackbarSuccess,
    draggable,
    NumberPicker,
    PageTitle,
    CustomField,
  },
  mixins: [formStatus],
}
</script>

<style scoped lang="sass">
.short-text-field
  max-width: 30rem

.list-item
  transition: all .3s
  .theme--dark &
    &.active
      background: hsla(0,0%,100%,.1)
  .theme--light &
    &.active
      background: rgba(0,0,0,.1)

.sticky
  position: sticky
  top: 5rem

.no-wrap
  white-space: nowrap

.closed
  opacity: .5
</style>
